import { createSelector } from 'reselect';
import { getNotifications } from '../notifications'

export function getNotificationList(state) {
  return state.notificationlists;
}

export function getNotificationListById(state, searchId) {
  return getNotificationList(state).get(searchId);
}

//=====================================
//  MEMOIZED SELECTORS
//-------------------------------------

export const getCurrentNotificationList = createSelector(
  getNotificationList,
  notificationlists => notificationlists.get(notificationlists.get('currentNotificationListId'))
);

export const getNotificationsForCurrentNotificationList = createSelector(
  getCurrentNotificationList,
  getNotifications,
  ( notificationlists, notifications) => {
    return notificationlists.notifiactionIds.map( id => notifications.get(id) );
  }
);
